<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-26 14:42:52
 * @FilePath: \qctsw-vue\packages\app\src\pages\complaint\list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import MenuComplaintColumn from './components/MenuComplaintColumn.vue'
import ComplaintColumnAll from './components/ComplaintColumnAll.vue'
import ComplaintColumnCollective from './components/ComplaintColumnCollective.vue'
import ComplaintColumnMore from './components/ComplaintColumnMore.vue'
import { useGetRouteQuery } from '~/shared/function'

const type = useGetRouteQuery('type', '0')
</script>

<template>
  <div bg-slate-1 public-page>
    <div class="public-container">
      <NAlert type="error" :show-icon="false" closable class="mb-sm">
        仅显示最近三年投诉信息，如需查询更早历史投诉，请<NuxtLink class="font-bold text-red-5 underline underline-2" :to="APP_ROUTER.complaintSearch()">
          通过投诉编号进行检索
        </NuxtLink> ！
      </NAlert>
    </div>

    <div class="public-container flex">
      <div class="flex-grow min-w-0 bg-white rounded-md p-sm">
        <MenuComplaintColumn />
        <ComplaintColumnAll v-if="[0, 3, 4].includes(Number(type))" />
        <ComplaintColumnCollective v-else-if="Number(type) === 1" />
        <ComplaintColumnMore v-else-if="Number(type) === 2" />
        <BasicEmpty v-else />
      </div>
      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl">
        <RankHotComplaint class="sticky top-25" />
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
